export default "__VITE_ASSET__fI7hNHK$__"